const dayjs = require("dayjs");
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");

dayjs.extend(utc);
dayjs.extend(timezone);

export function calculateFirstClassDates(data, firstClass, userTimezone) {
    if (!firstClass || !data || !data?.timing?.start) {
        return null
    }
  const startTimeUnix = data?.timing?.start;
  const startTime = dayjs.tz(startTimeUnix, userTimezone)
  const startDateTime = dayjs.tz(firstClass, userTimezone)
      .hour(startTime.hour())
      .minute(startTime.minute())
      .second(startTime.second())
      .millisecond(startTime.millisecond())
  return startDateTime.utc().valueOf();
}
export function calculateLastClassDates(
  propLastClass,
  firstClass,
  duration,
  userTimezone,
  formattedTimes
) {
  const firstClassDay = dayjs.tz(firstClass, userTimezone);

  const scheduledWeekdays = Object.keys(formattedTimes).map((ts) =>
    dayjs(Number(ts)).tz(userTimezone).day()
  );

  const adjustedDays = scheduledWeekdays.map(d => (d === 0 ? 7 : d));
  const latestAdjustedDay = Math.max(...adjustedDays);
  const latestDay = latestAdjustedDay === 7 ? 0 : latestAdjustedDay;

  const lastWeekStart = firstClassDay.add(duration - 1, 'weeks');

  const daysToMonday = (7 + lastWeekStart.day() - 1) % 7;
  const lastWeekMonday = lastWeekStart.subtract(daysToMonday, 'day');

  const lastClassDay = lastWeekMonday.add(latestAdjustedDay - 1, 'day')

  const matchingTime = Object.entries(formattedTimes).find(([ts]) => {
    const d = dayjs(Number(ts)).tz(userTimezone);
    return d.day() === latestDay;
  });

  const classTime = matchingTime ? matchingTime[1] : propLastClass.timing;
  const startTime = dayjs.tz(classTime.start, userTimezone);

  const finalClassDate = lastClassDay
      .hour(startTime.hour())
      .minute(startTime.minute())
      .second(startTime.second())
      .millisecond(startTime.millisecond())
  return finalClassDate.utc().valueOf();
}